/**
 * @desc 详情信息
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.BizPermissionApplyResponseDto>;
export function request(paNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bizPermissionApply/${paNo}/info`, {
      method: "GET",

      ...options,
    }),
  );
}
